// api/profile.js
import { apiClient } from "./apiclient";

// GET /user/profile/{id} — fetch the logged-in user's own profile
export async function getMyProfile(token, userInfoId) {
  try {
    const res = await apiClient.get(`/user/profile/${userInfoId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    throw new Error("Failed to load profile");
  }
}

// PUT /user/profile/{id} — update own name / mobile
export async function updateMyProfile(token, userInfoId, { name, mobile }) {
  try {
    const res = await apiClient.put(
      `/user/profile/${userInfoId}`,
      { name, mobile },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  } catch (err) {
    throw new Error("Failed to update profile");
  }
}

// PUT /user/profile-picture/{id} — upload/replace own photo
export async function updateMyProfilePicture(token, userInfoId, file) {
  const formData = new FormData();
  formData.append("photo", file);

  try {
    const res = await apiClient.put(
      `/user/profile-picture/${userInfoId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // let axios set the boundary
        },
      }
    );
    return res.data;
  } catch (err) {
    throw new Error("Failed to upload photo");
  }
}

// GET /user/profile-picture/{id}/image — fetch photo bytes with auth header,
// convert to a local blob URL the browser can display in an <img> tag
export async function resolvePhotoUrl(token, photoUrl) {
  if (!photoUrl) return null;
  try {
    const res = await apiClient.get(photoUrl, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    });
    return URL.createObjectURL(res.data);
  } catch (err) {
    return null;
  }
}